module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc7-56531df84b75313a95ac79076246b0ec.jpg";